import { tabProps } from "../interfaces/sidebar";

export const tabs: tabProps[] = [
    {
        id: "dashboard",
        label: "Dashboards",
        icon: "dashboard",
        navigate:"",
        children:[
            {
                id: "dashboardStock",
                label: "Dashboard Stock",
                icon: "dashboardStock",
                navigate: "dashboardStock"
            },
            {
                id: "dashboard",
                label: "Dashboard Leads",
                icon: "dashboardEx",
                navigate: "dashboard"
            },
            {
                id: "dashboardit",
                label: "Dashboard Performance",
                icon: "dashboardIt",
                navigate: "dashboardIt"
            },
            {
                id: "dashboardIntegrations",
                label: "Dashboard Integraciones",
                icon: "dashboardIntegrations",
                navigate: "dashboardIntegrations"
            }
        ]
    },
    {
        id: "dealerships",
        label: "Concesionarias",
        icon: "dealerships",
        navigate: "dealerships"
    },
    {
        id: "brands",
        label: "Marcas",
        icon: "brands",
        navigate: "brands"
    },
    {
        id: "users",
        label: "Usuarios",
        icon: "users",
        navigate: "users"
    },
    {
        id: "reportes",
        label: "Reportes",
        icon: "report",
        navigate: "",
        children: [
            {
                id: "leadsReports",
                label: "Reportes Leads",
                icon: "report",
                navigate: "leads-reports"
            },
            {
                id: "tycReport",
                label: "Reporte TyC",
                icon: "report",
                navigate: "tyc-report"
            },
            {
                id: "linzeSalesReport",
                label: "Ventas Linze",
                icon: "report",
                navigate: "ventas-linze-report"
            }
        ]
    },
    {
        id: "leads",
        label: "Leads",
        icon: "leads",
        navigate: "",
        children: [
            {
                id: "leadsGeneral",
                label: "Leads Concesionarios",
                icon: "leadsGeneral",
                navigate: "leads"
            },
            {
                id: "leadsBrands",
                label: "Leads Marcas",
                icon: "leadsBrands",
                navigate: "leads-marcas"
            }
        ]
    },
    {
        id: "manualSale",
        label: "Venta Manual",
        icon: "manualSale",
        navigate: "venta-manual"
    },
    {
        id: "publications",
        label: "Publicaciones",
        icon: "publications",
        navigate: "publications",
        children: [
            {
                id: "pendings",
                label: "Publicaciones en revisión",
                icon: "review",
                navigate: "pendings",
                type: "param"
            },
            {
                id: "alls",
                label: "Todas las publicaciones",
                icon: "allPublications",
                navigate: "all",
                type: "param"
            },
            {
                id: "notPublished",
                label: "No republicados",
                icon: "notPublished",
                navigate: "notPublished",
                type: "param"
            },
        ]
    },
    {
        id: "settings",
        label: "Configuración",
        icon: "settings",
        navigate: "settings",
        children: [
            {
                id: "terms",
                label: "Terminos y condiciones",
                icon: "terms",
                navigate: "terms"
            },
            {
                id: "additionalCosts",
                label: "Costos adicionales",
                icon: "additionalCosts",
                navigate: "additionalCosts"
            },
            {
                id: "payments",
                label: "Instrucciones de pago",
                icon: "payments",
                navigate: "payments"
            },
            {
                id: "pickupPoints",
                label: "Puntos de inspección",
                icon: "pickupPoints",
                navigate: "pickupPoints"
            }
        ]
    }
];